import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getData } from '@yme/api';
import { RelatedExperiences } from '@yme/components/Destinations/components/RelatedExperiences';
import { QueryParamName } from '@yme/components/Destinations/constants';
import { IndentWrapper } from '@yme/components/Separator';
import { useIsMount } from '@yme/hooks/index';
import { getIsInAuthor, getRootLang } from '@yme/selectors/index';
import { getProductName, getProductSlug } from '@yme/selectors/products';
import { useTranslation } from '@yme/services/i18n';
import { UnitRelatedExperienceSkeleton } from './UnitRelatedExperienceSkeleton';
import { buildRequestUrl, getDataForDestinationCard } from './helpers';
export const UnitRelatedExperience = ({ experiencesRootPath, title, elpURL, edpURL, isRemoveBottomIndent, isInEditor, }) => {
    const { t } = useTranslation();
    const [destinations, setDestinations] = useState([]);
    const [isLoadedDestinations, setIsLoadedDestinations] = useState(false);
    const productSlug = useSelector(getProductSlug);
    const productName = useSelector(getProductName);
    const language = useSelector(getRootLang);
    const isInAuthor = useSelector(getIsInAuthor);
    const isMount = useIsMount();
    useEffect(() => {
        if (!productSlug || !experiencesRootPath || isMount)
            return;
        const getUnitRelateExperience = async () => {
            try {
                const response = await getData(buildRequestUrl(productSlug, experiencesRootPath));
                const data = response.data?.destinationList?.items ?? [];
                const destinationData = data.map((destination) => getDataForDestinationCard(destination, language, edpURL, isInAuthor));
                setDestinations(destinationData);
            }
            catch (error) {
            }
            finally {
                setIsLoadedDestinations(true);
            }
        };
        getUnitRelateExperience();
    }, [edpURL, experiencesRootPath, isInAuthor, isMount, language, productSlug]);
    if (!isInEditor && experiencesRootPath && !isLoadedDestinations) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(UnitRelatedExperienceSkeleton, null)));
    }
    if (!productSlug || !experiencesRootPath || !destinations.length)
        return null;
    return (React.createElement(RelatedExperiences, { experiencesData: destinations, viewAllPath: elpURL, itemName: productName, searchParamName: QueryParamName.UNITS_QUERY_PARAM, title: title ?? t('destinations_unitRelatedExperiences_header'), isRemoveBottomIndent: isRemoveBottomIndent }));
};
